



























import { ref, computed, defineComponent, onMounted, PropType, watch } from '@vue/composition-api';
import { cloneDeep } from 'lodash-es';
import { percentageToNumber } from '../filter';
import { SelectorsType, ChartDataCardRecordType } from '../types';
import QaTips from './qa-tips.vue';
import { hexToRgba, toThousands } from '@/common/util'
export default defineComponent({
    name: "charts-card", // 卡片组件
    components: {
        QaTips

    },
    props: {
        isClick: {
            type: Boolean,
            default: true
        },
        data: {
            type: Array as PropType<ChartDataCardRecordType[]>,
            required: true
        },
        configData: {
            type: Object,
            required: true
        },
        value: {
            type: Array as PropType<string[]>,
            default: ()=> []
        }
    },
    model: {
        prop: 'value',
        event: 'update',
    },
    setup(props, context) {
        const activeArray = computed({
            get: () => {
                return props.value;
            },
            set: (val) => {
                return context.emit('update', val);
            },
        });
        // 需要循环的selectors，循环的是config，再根据config的fileNmae找到对应的值
        const selectors = computed(() => props.configData.selectors)

        onMounted(() => {
            // 默认都是选中的
            // props.configData.selectors.map((item: SelectorsType) => activeArray.value.push(item.fieldName))
        })

        // 点击卡片
        function clickCard(configItem: SelectorsType) {
            if(!props.isClick)  return;
            if( activeArray.value.includes(configItem.fieldName)) {
                const index = activeArray.value.findIndex( (value: string) => value === configItem.fieldName)
                activeArray.value.splice(index, 1);
            } else {
                activeArray.value.push(configItem.fieldName);
            }
            context.emit('click', configItem)
        }

        // 样式控制
        function styleFn(configItem: SelectorsType) {
            // 不可点击，默认全都是选中的；可点击，需要判断当前card是否选中
            const active = props.isClick ? activeArray.value.includes(configItem.fieldName) : true;
            const styleColor = configItem.displaySetting && JSON.parse(configItem.displaySetting).color; // 可能存在undefined
            return {
                'backgroundColor': active ? hexToRgba(styleColor ?? '#1D59F2',.05) : '#FAFBFC',
                'borderBottom': active ? `2px solid ${ styleColor ?? '#1D59F2'}` : `0 solid #FAFBFC`
            }
        }

        // 循环的是config里的selectors，这样即使records为[],仍然可以展示模块
        function recordItem(configItem: SelectorsType) {
           const record = props.data.find((item: ChartDataCardRecordType) => item.field_name === configItem.fieldName)!;
           const link_rate_value = record && record.link_rate_value || '0'; // 暂时先手动塞一个吧
           const rateNumber = percentageToNumber(link_rate_value);
           return {
                value: record && toThousands(record.value, !Number.isInteger(record.value)) || 0,
                class: rateNumber > 0 ? 'up' : 'low',
                text: rateNumber > 0 ? `+${link_rate_value}` : `${link_rate_value}`
           }
        }

        watch(
            () => props.configData.selectors,
            () => {
                activeArray.value = [];
                props.configData.selectors.map((item: SelectorsType) => activeArray.value.push(item.fieldName))
            }
        )


        return {
            recordItem,
            selectors,
            activeArray,
            hexToRgba,
            clickCard,
            styleFn
        }
    },
})
